<template>
    <v-form-field v-bind="$props">
        <template v-slot:append>
            <slot name="append"></slot>
        </template>
        <template v-slot:label-prepend>
            <slot name="label-prepend"></slot>
        </template>
        <template v-slot:label-append>
            <slot name="label-append"></slot>
        </template>
        <template v-slot:label>
            <slot name="label"></slot>
        </template>
        <template v-slot:content>
            <v-autocomplete
                    v-model="selectValue"
                    class="form-input__border"
                    :items="itemList"
                    flat
                    solo
                    return-object
                    hide-details
                    :item-text="itemText"
                    :item-value="itemValue"
                    dense
                    @change="onchange"
            ></v-autocomplete>
        </template>
    </v-form-field>
</template>
<script>
    export default {
        name: "FormAutoCompleteField.vue",
        props: {
            small: {
                type: Boolean,
                default: false
            },
            xSmall: {
                type: Boolean,
                default: false
            },
            xxSmall: {
                type: Boolean,
                default: false
            },
            middle: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            },
            xLarge: {
                type: Boolean,
                default: false
            },
            xxLarge: {
                type: Boolean,
                default: false
            },
            label: {
                type: String
            },
            disable: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false
            },
            text: {},
            placeholder: {type: String},
            autofocus: {
                type: Boolean,
                default: false
            },
            labelWidth: {
                type: Number
            },
            fieldWidth: {
                type: Number
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            removeLabel: {
                type: Boolean,
                default: false
            },
            items: String,
            dataItems: {
                type: Array
            },
            value: null,
            dataApi: String,
            itemText: {
                type: String,
                default: 'text'
            },
            itemValue: {
                type: String,
                default: 'value'
            },
            dataQueryParam: {}
        },
        data() {
            return {
                itemList: [],
                selectValue: null
            }
        },
        watch: {
            value(val) {
                this.selectValue = val;
            },
            dataItems(val) {
                if (val) {
                    this.itemList = [];
                    val.forEach(x => this.itemList.push({text: x[this.itemText], value: x[this.itemValue]}));
                }
            }
        },
        created() {
            this.selectValue = this.value;
            if (this.dataApi) {
                this.loadRemoteApi();
            } else if (this.dataItems) {
                this.dataItems.forEach(x => this.itemList.push({text: x[this.itemText], value: x[this.itemValue]}));
            } else {
                this.parseExpression(this.items);
            }
        },
        methods: {
            parseExpression(exp) {
                if (exp) {
                    let exps = exp.split(",");
                    exps.forEach(item => {
                        let ss = item.split("|");
                        this.itemList.push({
                            text: ss[0],
                            value: ss.length > 1 ? ss[1] : ss[0]
                        })
                    })
                }
            },
            loadRemoteApi() {
                this.$request.request(this.dataApi, this.dataQueryParam).then(response => {
                    response.table.forEach(item => {
                        this.itemList.push({
                            text: item[this.itemText],
                            value: item[this.itemValue]
                        })
                    })
                })
            },
            onchange(val) {
                this.$emit('input', val);
                this.$emit('change', val);
            }
        }
    }
</script>